// extracted by mini-css-extract-plugin
export var container = "copy-module--container--Kqytm";
export var copyContainer = "copy-module--copyContainer--eirtE";
export var asideText = "copy-module--asideText--hM+3f";